import http from "@/api/client";

export async function listTables(params = {}) {
  const { data } = await http.get("/tables", { params });
  return data;
}

export async function getTable(code) {
  const { data } = await http.get(`/tables/${encodeURIComponent(code)}`);
  return data;
}
